import React from "react";
import iconPdf from "../../img/icons-ext-file/iconPdf.png"

export default function FilePdf() {
    return (
        <img src={iconPdf} alt="" />
    );
}